export default {"src":"/_next/static/media/icone-profile.0627f586.svg","height":34,"width":28,"blurWidth":0,"blurHeight":0};